import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import { resolveGranularity } from 'utils/executive.utils'
import type { GetRevenueParams, RevenueTrendResponse, ExecutiveFilterState } from 'api/executive/executive.types'

export function useRevenueTrend(
  scopedFilters?: Partial<ExecutiveFilterState>,
  widgetKey = 'performance.revenue-trend'
) {
  return useExecutiveQuery<GetRevenueParams, RevenueTrendResponse>(
    widgetKey,
    PerformanceApi.getRevenueTrend,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        procedureId: f.procedureId ?? undefined,
        patientType: f.patientType ?? undefined,
        granularity: resolveGranularity(f.dateRange.start, f.dateRange.end),
      }
    },
    { scopedFilters }
  )
}
